export default __webpack_public_path__ + "static/media/background-parachute-1x.86ea6415.png";